// extracted by mini-css-extract-plugin
export default {"root":"StartAppointmentModal_root__c5XJc","heading":"StartAppointmentModal_heading__0yaJl","actions":"StartAppointmentModal_actions__wOc5e"};